import React, {useEffect} from 'react';
import { useState } from 'react';
import { Button, TextField, Typography } from '@mui/material';
import './Login.css';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/useAuth';
import axios from '../../api/axios';

export const Login = (props) => {
    const { auth, setAuth } = useAuth();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState(false);
    const [isCountdownActive, setIsCountdownActive] = useState(false);
    const [finishDate, setFinishDate] = useState(localStorage.getItem('finishDate') ?? 0);

    useEffect(() => {
      if (finishDate > Date.now()) {
        setErrorMessage(true);
        setIsCountdownActive(true);
      }
    }, []);

    useEffect(() => {
      localStorage.setItem('finishDate', finishDate.toString())
    }, [finishDate]);


    const disabledCondition = password === null || password.trim() === ''
      || username === null || username.trim() === '';

    const navigate = useNavigate();

    const handleLogin = async () => {
      const user = {name: username, password};
      setErrorMessage(null);

      await axios.post('/Users/authenticate', user)
        .then((res) => {
          setAuth(res.data);
          navigate('/');
          props.callBackFromParent(res.data);
        })
        .catch(e => {
          console.log(e)
          if (e?.response?.data?.message !== 'Invalid phone or password') {
            setErrorMessage(true);
            setIsCountdownActive(true);
            let curDate = new Date();
            setFinishDate(curDate.setSeconds(curDate.getSeconds() + 60));
          } else {
            alert(e.response.data.message)
          }
        });
    }




  const Countdown = ({setIsCountdownActive, finishDate}) => {
    const [isTimeout, setIsTimeout] = useState(false);
    const [timerId, setTimerID] = useState(0);
    const [diffSeconds, setDiffSeconds] = useState(0);
    const [tick, setTick] = useState(false);

    useEffect(() => {
      const diff = Math.floor((finishDate - Date.now()) / 1000);
      if (diff === 0 || diff < 0) {
        setIsTimeout(true);
        setIsCountdownActive(false);
        localStorage.removeItem("finishDate");
        return;
      }
      setDiffSeconds(diff);
    }, [tick, finishDate]);

    useEffect(() => {
      if (isTimeout) clearInterval(timerId);
    }, [isTimeout, timerId]);

    useEffect(() => {
      const timerID = setInterval(() => {
        setTick(!tick);
      }, 1000);
      setTimerID(timerID);
      return () => clearInterval(timerID);
    }, [tick]);

    return (
      <Typography style={{alignSelf: 'center', color: 'red'}}>
        {`${diffSeconds.toString()}`}
      </Typography>
    )
  }



  return (
    <div className='container'>
      <Typography variant="h4" className='title'>Furniture App Administration</Typography>
        <div className='form'>
            <TextField
              label='Введите username' name="login" type="text" required={true} style={{marginBottom: '20px'}} disabled={isCountdownActive}
                value={username} onChange={e => {setUsername(e.target.value); setErrorMessage(null);}} />
            <TextField
              label='Введите пароль' name="password" type="password" required={true} style={{marginBottom: '20px'}} disabled={isCountdownActive}
                value={password} onChange={e => {setPassword(e.target.value); setErrorMessage(null);}} />
          <Button className='button'
                   type="submit"
                   disabled={disabledCondition || isCountdownActive}
                   variant="outlined"
                   onClick={() => handleLogin()}
          >
            Войти
          </Button>

          { errorMessage && isCountdownActive &&
          <Typography style={{alignSelf: 'center', color: 'red'}}>
            API calls quota exceeded! Maximum admitted 3 per minute
          </Typography> }

          { errorMessage && isCountdownActive && <Countdown setIsCountdownActive={setIsCountdownActive} finishDate={finishDate}/> }
        </div>
    </div>
  )
}
